var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.186 4.082c-.308-.308-.796-.308-1.078 0a5.6 5.6 0 0 0-1.643 3.98c0 1.489.59 2.9 1.643 3.98.154.153.36.23.539.23s.385-.077.54-.23c.307-.309.307-.797 0-1.08a4.06 4.06 0 0 1-1.208-2.875c0-1.078.437-2.105 1.207-2.875.283-.334.283-.822 0-1.13",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.769 18.69-5.494-5.52a8.6 8.6 0 0 0 1.258-2.079 8.2 8.2 0 0 0 .59-3.03 8.2 8.2 0 0 0-.59-3.029A8.1 8.1 0 0 0 11.09.591 8.2 8.2 0 0 0 8.061 0a8.2 8.2 0 0 0-3.029.59A8.1 8.1 0 0 0 .591 5.033 8.2 8.2 0 0 0 0 8.062a8.2 8.2 0 0 0 .59 3.03 8.1 8.1 0 0 0 4.442 4.44 8.2 8.2 0 0 0 3.03.591 8.2 8.2 0 0 0 3.03-.59 7.2 7.2 0 0 0 2.079-1.258l5.52 5.494c.154.154.36.231.539.231a.74.74 0 0 0 .539-.231c.308-.282.308-.77 0-1.078M8.062 14.558a6.43 6.43 0 0 1-4.596-1.9 6.493 6.493 0 0 1 0-9.191 6.5 6.5 0 0 1 4.596-1.9c1.668 0 3.337.642 4.595 1.9a6.493 6.493 0 0 1 0 9.191 6.43 6.43 0 0 1-4.595 1.9",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.88273a8a4271800bbec7536dfab72f2d.svg";
export { ForwardRef as ReactComponent };